import { Workout } from "../../libs/workout/types";
import { WorkoutTables } from "../WorkoutTables";

type Props = {
  open: boolean;
  loading: boolean;
  workout: Workout | null;
  userName?: string;
  userId?: number;
  onClose: () => void;
};

/**
 * Modale che mostra una scheda dello storico col rendering identico alla
 * dashboard (riusa `WorkoutTables`, in sola lettura).
 */
export const WorkoutViewModal: React.FC<Props> = ({
  open,
  loading,
  workout,
  userName,
  userId,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 p-4 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-7xl my-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-900 rounded-t-2xl z-10">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {workout?.name || "Scheda"}
            </h3>
            {userName && (
              <p className="text-xs text-gray-500 dark:text-gray-400">{userName}</p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"
            title="Chiudi"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-6 pb-6">
          {loading || !workout ? (
            <div className="flex items-center justify-center py-16 text-gray-500 dark:text-gray-400">
              <svg className="animate-spin h-6 w-6 mr-3 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12z" />
              </svg>
              Caricamento scheda...
            </div>
          ) : (
            <WorkoutTables workout={workout} userId={userId} />
          )}
        </div>
      </div>
    </div>
  );
};
